<template>
  <div v-if="!hideBranding">
    <slot />
  </div>
</template>
<script setup lang="ts">
import { useBranding } from '@/composables/useBranding';

const { hideBranding } = useBranding();
</script>
